// extracted by mini-css-extract-plugin
export default {"inputAudio":"styles_inputAudio__yPBmF","inputAudioDropzone":"styles_inputAudioDropzone__C8SWe"};